import React from 'react';

const FormField = ({
  label,
  htmlFor,
  error,
  required = false,
  children,
  className = '',
  hint,
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label
          htmlFor={htmlFor}
          className="mb-2.5 block font-medium text-black dark:text-white"
        >
          {label}
          {required && <span className="text-danger ml-1">*</span>}
        </label>
      )}

      {children}

      {hint && !error && (
        <p className="mt-1 text-sm text-bodydark2">{hint}</p>
      )}

      {error && (
        <p className="mt-1 text-sm text-danger">{error}</p>
      )}
    </div>
  );
};

export default FormField;
